/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type TermRecurrenceMode = typeof TermRecurrenceMode[keyof typeof TermRecurrenceMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermRecurrenceMode = {
  Chain: 'Chain',
  Days: 'Days',
  Weeks: 'Weeks',
} as const;
